<template>
	<div>
		<v-row class="text-center">
			<v-col cols="12" class="font-type text-left headline">
				{{ title }}
			</v-col>
			<v-col>
				<v-chip-group column class="p-0" @change="setPersonsSelected">
					<v-chip filter value="all" color="accent" class="ma-1">
						<v-avatar left class="accent darken-4">{{ persons.length }}</v-avatar>
						Todos
					</v-chip>
					<v-chip
						filter
						value="created"
						color="success"
						class="ma-1"
						v-if="personsCreate.length"
					>
						<v-avatar left class="success darken-4">
							{{ personsCreate.length }}
						</v-avatar>
						Creado
					</v-chip>
					<v-chip
						filter
						value="invite"
						color="primary"
						class="ma-1"
						v-if="personsInvite.length"
					>
						<v-avatar left class="primary darken-4">
							{{ personsInvite.length }}
						</v-avatar>
						Invitado
					</v-chip>
					<v-chip
						filter
						value="shared"
						color="info"
						class="ma-1"
						v-if="personsShared.length"
					>
						<v-avatar left class="info darken-4">
							{{ personsShared.length }}
						</v-avatar>
						Compartido
					</v-chip>
				</v-chip-group>
				<document-chip :chips-list="chipsList" :onChangeChips="onChangeChips" />
				<div class="warning--text caption text-left">{{ warningMessage }}</div>
			</v-col>
		</v-row>
		<div v-if="persons.length" class="maxHeightListPerson">
			<v-list two-line class="backgroundTransparent">
				<template v-for="person in personsSelected">
					<person-list-item v-if="person" :key="person._id + title" :person="person" />
				</template>
			</v-list>
		</div>
		<v-card flat v-if="!persons.length" height="60" class="text-center">
			<v-card-text class="headline">
				<v-icon large left>mdi-account-circle</v-icon>{{ msjnodata }}
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
export default {
	components: {
		PersonListItem: () => import('@/components/persons/PersonListItem.vue'),
		documentChip: () => import('@/components/persons/PersonDocumentChip.vue'),
	},
	props: {
		title: { type: String, default: '' },
		warningMessage: { type: String, default: '' },
		msjnodata: { type: String, default: '' },
		toggle: { type: Boolean },
		persons: { type: Array, default: () => [] },
		personsInvite: { type: Array, default: () => [] },
		personsShared: { type: Array, default: () => [] },
		personsCreate: { type: Array, default: () => [] },
		onChangeChips: { type: Function, required: true },
		chipsList: { type: Array, default: () => [] },
	},
	data() {
		return {
			personsSelected: [],
		};
	},
	mounted() {
		this.setPersonsSelected();
	},
	methods: {
		setPersonsSelected(value) {
			switch (value) {
				case 'created':
					this.personsSelected = this.personsCreate;
					break;
				case 'invite':
					this.personsSelected = this.personsInvite;
					break;
				case 'shared':
					this.personsSelected = this.personsShared;
					break;
				case 'all':
					this.personsSelected = this.persons;
					break;
				default:
					this.personsSelected = this.persons;
					break;
			}
		},
	},
	watch: {
		persons() {
			this.setPersonsSelected();
		},
	},
};
</script>
<style>
.maxHeightListPerson {
	max-height: 500px;
	overflow-y: auto;
}
.font-type {
	font-family: roboto;
}
</style>
